import './App.css';
import { configureReducer } from './redux';
import { Provider } from 'react-redux';
import Router from './route/Router';
import { apolloClient } from './service/apolloClient';
import { ApolloProvider } from '@apollo/client';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const store = configureReducer();

function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={store}>
        <Router />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
      </Provider>
    </ApolloProvider>
  );
}

export default App;
